import { Controller } from "stimulus"
import Isotope from "isotope-layout"

export default class extends Controller {
  static targets = ["grid", "tab", "searchInput", "clearBtn", "noResults"]

  connect() {
    this.currentCategory = "all"
    this.currentSearch = ""
    setTimeout(function() { this.initIsotope() }.bind(this), 100)
  }

  initIsotope() {
    if (!this.hasGridTarget) return

    this.iso = new Isotope(this.gridTarget, {
      itemSelector: ".store-isotope-item",
      layoutMode: "fitRows",
      percentPosition: true
    })
  }

  filterByCategory(event) {
    var category = event.currentTarget.dataset.category

    this.tabTargets.forEach(function(tab) {
      if (tab.dataset.category === category) {
        tab.classList.add("active")
      } else {
        tab.classList.remove("active")
      }
    })

    this.currentCategory = category
    this.applyFilters()
  }

  filterBySearch() {
    this.currentSearch = this.hasSearchInputTarget ? this.searchInputTarget.value.toLowerCase().trim() : ""
    this.toggleClearBtn()
    this.applyFilters()
  }

  clearSearch() {
    if (this.hasSearchInputTarget) {
      this.searchInputTarget.value = ""
    }
    this.currentSearch = ""
    this.toggleClearBtn()
    this.applyFilters()
  }

  toggleClearBtn() {
    if (this.hasClearBtnTarget) {
      if (this.currentSearch) {
        this.clearBtnTarget.classList.remove("d-none")
      } else {
        this.clearBtnTarget.classList.add("d-none")
      }
    }
  }

  applyFilters() {
    if (!this.iso) return

    var cat = this.currentCategory
    var search = this.currentSearch

    this.iso.arrange({
      filter: function() {
        var el = this
        var itemCategory = el.getAttribute("data-category") || ""
        var itemName = el.getAttribute("data-name") || ""
        var matchesCategory = cat === "all" || itemCategory === cat
        var matchesSearch = !search || itemName.indexOf(search) !== -1
        return matchesCategory && matchesSearch
      }
    })

    if (this.hasNoResultsTarget) {
      if (this.iso.filteredItems.length === 0) {
        this.noResultsTarget.classList.remove("d-none")
      } else {
        this.noResultsTarget.classList.add("d-none")
      }
    }
  }

  disconnect() {
    if (this.iso) {
      this.iso.destroy()
      this.iso = null
    }
  }
}
